import { createContext } from 'react'

import { ERecommendationToCollectionMapper } from '../../domains/Product/ProductRecommendation'

interface IPageDataContext extends Record<string, unknown> {
  recommendationCollectionIdMapper: ERecommendationToCollectionMapper
}

const PageDataContext = createContext<IPageDataContext>({} as IPageDataContext)

export default PageDataContext
